export default "__VITE_ASSET__BgtDjKvF__"